import {put, takeLatest, call} from 'redux-saga/effects';
import * as optionService from "../../../../services/optionService";
import {
    UNDELETE_OPTION,
    GET_OPTIONS_SUCCESS,
    UNDELETE_OPTION_ERROR,
}
    from "../../../actions/menu/options";

function* unDeleteOptionSaga(action) {
    try {
        yield call(optionService.UnDeleteOption, action.payload)
        yield put({
            type: GET_OPTIONS_SUCCESS,
            payload: action.payload._id
        });

    } catch (error) {
        yield put({
            type: UNDELETE_OPTION_ERROR,error: error.data
        });
    }
}


export function* unDeleteOptionSagaWatcher() {
    yield takeLatest(UNDELETE_OPTION, unDeleteOptionSaga);
}